import { FormEvent, useContext, useState } from 'react'
import UserContext from '../../context/UserContext';
import { Button, Chip, Modal, Table } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import FormWrapper from '../../components/forms/FormWrapper';
import { SUBMIT_CHANGE_MY_PASSWORD } from '../../graphql/queries';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

export default function MyProfilePage() {
   const userCtx = useContext(UserContext);
   const [opened, { open, close }] = useDisclosure(false);
   const navigate = useNavigate()

   const [submitChangeMyPassword, { loading }] = useMutation(SUBMIT_CHANGE_MY_PASSWORD);
   const user = userCtx?.user
   const [formData, setFormData] = useState<Map<string, any>>(new Map())
   const handleChange = ({ name, value }: any) => {
      setFormData((prev) => {
         return new Map([...prev, [name, value]])
      })
   }
   const handleSubmit = (ev: FormEvent) => {
      ev.preventDefault()
      console.log({ formData })
      submitChangeMyPassword({
         variables: {
            data: Object.fromEntries(formData)
         }
      }).then((res) => {
         close()
      })
   }
   return (
      <div className="p-8 bg-slate-50 flex flex-col gap-4">
         <h3>Welcome, {user?.firstName} {user?.lastName}</h3>
         <Table p={4} withTableBorder withColumnBorders>
            <Table.Tbody>
               <Table.Tr>
                  <Table.Td fw="bold">Role</Table.Td>
                  <Table.Td>{user?.role.name}</Table.Td>
               </Table.Tr>
               <Table.Tr>
                  <Table.Td fw="bold">Privileges</Table.Td>
                  <Table.Td>
                     <div className='flex text-xs flex-wrap gap-1'>
                        {user?.role.permissions.map((p: any) => {
                           return <Chip size='xs'>{p.privilege}</Chip>
                        })}
                     </div>
                  </Table.Td>
               </Table.Tr>
               <Table.Tr>
                  <Table.Td fw="bold">Password</Table.Td>
                  <Table.Td>
                     <Button onClick={() => open()} variant='outline'>Change password</Button>
                  </Table.Td>
               </Table.Tr>
            </Table.Tbody>
         </Table>
         <Modal opened={opened} onClose={close} title="Change My Password">
            <form onSubmit={handleSubmit} className='flex flex-col gap-4'>
               <FormWrapper fields={[
                  { name: "newPassword", label: "New password", options: { required: true }, type: "password" }
               ]} formData={formData} updateFormData={handleChange} />
               <div className='flex justify-end items-center'>
                  <Button type='submit'>{loading ? "Submiting, please wait ..." : "Submit"}</Button>
               </div>
            </form>
         </Modal>
      </div>
   )
}

